export default __webpack_public_path__ + "static/media/googlePlay.f902960a.png";